/* eslint-disable */

//import $ from 'jquery'
import { map, clone } from 'lodash/core';
import helper from '../../../vueHelper'
import {
  Slick
} from 'ls-slickgrid-es6'
//import { publicDecrypt } from "crypto";

export default ModeManager

function ModeManager(
  options,
  vueslickgrid, //pass the vueslickgrid component instance
  vm //TODO: remove this parameter
) {
  let dataView = vueslickgrid.dataView
  let $topButtonBar = $(vueslickgrid.$refs["top-button-bar"])
  let $bottomButtonBar = $(vueslickgrid.$refs["bottom-button-bar"])
  let $slickModal = $(vueslickgrid.$refs.slickModal)
  let _vm = vm //TODO: remove this parameter
  let tempData
  let tempSelectedRows
  let $btnAddTop
  let $btnEditTop
  let $btnCancelTop
  let $btnApplyTop
  let $btnCopyTop
  let $btnDeleteTop
  let $btnExportTop
  let $btnUploadTop
  let $btnAddBottom
  let $btnEditBottom
  let $btnCancelBottom
  let $btnApplyBottom
  let $btnCopyBottom
  let $btnDeleteBottom
  let $btnExportBottom
  let $btnUploadBottom
  let _dataView = dataView
  let _grid
  let _self = this
  let _currentIndex = 0
  let _previousPagingCount

  var _defaultMode = {
    modeManager: {
      currentMode: 'view',
      useBottomButtonBar: true,
      useTopButtonBar: false,
      showAdd: true,
      showEdit: true,
      showCopy: true,
      showApply: true,
      showCancel: true,
      showDelete: false,
      showExport: false,
      showUpload: false
    }
  }

  var _options = options || {}

  function init(grid) {
    _grid = grid
    //updated by Alan Chow on 20200117 to let the options override the default.
    let temp = $.extend(true, {}, _defaultMode, options)
    _options = $.extend(true, options, temp) //copy the default to the option without change the object, we want to share the options
    //_options = options;

    constructModeManagerUI()
    toggleMode()
  }

  function constructModeManagerUI() {
    //$topButtonBar = $(this.$refs.topButtonBar);
    //$bottomButtonBar = $(this.$refs.bottomButtonBar);
    $btnAddTop = $('<button class="btn btn-primary">'+helper.getWord('Add')+'</button>')
    $btnEditTop = $('<button class="btn btn-primary">'+helper.getWord('Edit')+'</button>')
    $btnCancelTop = $(
      '<button class="btn btn-primary" id="slickgrid_cancel_top" data-toggle="modal" data-target="#' +
      $slickModal.attr('id') +
      '">'+helper.getWord('Cancel')+'</button>'
    )
    $btnApplyTop = $(
      '<button class="btn btn-primary" id="slickgrid_apply_top" data-toggle="modal" data-target="#' +
      $slickModal.attr('id') +
      '">'+helper.getWord('Apply')+'</button>'
    )
    $btnCopyTop = $('<button class="btn btn-primary">'+helper.getWord('Copy')+'</button>')
    $btnDeleteTop = $('<button class="btn btn-primary">'+helper.getWord('Delete')+'</button>')
    $btnExportTop = $('<button class="btn btn-primary">'+helper.getWord('Export')+'</button>')
    $btnUploadTop = $('<button class="btn btn-primary">'+helper.getWord('Upload')+'</button>')

    $btnAddBottom = $('<button class="btn btn-primary">'+helper.getWord('Add')+'</button>')
    $btnEditBottom = $('<button class="btn btn-primary">'+helper.getWord('Edit')+'</button>')
    $btnCancelBottom = $(
      '<button class="btn btn-primary"  id="slickgrid_cancel_bottom" data-target="#' +
      $slickModal.attr('id') +
      '">'+helper.getWord('Cancel')+'</button>'
    )
    $btnApplyBottom = $(
      '<button class="btn btn-primary"  id="slickgrid_apply_bottom" data-target="#' +
      $slickModal.attr('id') +
      '">'+helper.getWord('Apply')+'</button>'
    )
    $btnCopyBottom = $('<button class="btn btn-primary">'+helper.getWord('Copy')+'</button>')
    $btnDeleteBottom = $('<button class="btn btn-primary">'+helper.getWord('Delete')+'</button>')
    $btnExportBottom = $('<button class="btn btn-primary">'+helper.getWord('Export')+'</button>')
    $btnUploadBottom = $('<button class="btn btn-primary">'+helper.getWord('Upload')+'</button>')
    $topButtonBar.empty()
    $bottomButtonBar.empty()
    let $vm = this
    if (_options.modeManager.useTopButtonBar) {
      if (_options.modeManager.showAdd) {
        $topButtonBar.append($btnAddTop)
        $btnAddTop.on('click', btn_addClicked)
      }
      if (_options.modeManager.showEdit) {
        $topButtonBar.append($btnEditTop)
        $btnEditTop.on('click', btn_editClicked)
      }
      if (_options.modeManager.showAdd || _options.modeManager.showEdit || _options.modeManager.showCopy) {
        $topButtonBar.append($btnCancelTop)
        $btnCancelTop.on('click', btn_cancelClicked)
        $topButtonBar.append($btnApplyTop)
        $btnApplyTop.on('click', btn_applyClicked)
      }
      if (_options.modeManager.showCopy) {
        $topButtonBar.append($btnCopyTop)
        $btnCopyTop.on('click', btn_copyClicked)
      }
      if (_options.modeManager.showDelete) {
        $topButtonBar.append($btnDeleteTop)
      }
      if (_options.modeManager.showExport) {
        $topButtonBar.append($btnExportTop)
      }
      if (_options.modeManager.showUpload) {
        $topButtonBar.append($btnUploadTop)
      }
    }
    if (_options.modeManager.useBottomButtonBar) {
      if (_options.modeManager.showAdd) {
        $bottomButtonBar.append($btnAddBottom)
        $btnAddBottom.on('click', btn_addClicked)
      }
      if (_options.modeManager.showEdit) {
        $bottomButtonBar.append($btnEditBottom)
        $btnEditBottom.on('click', btn_editClicked)
      }
      if (_options.modeManager.showAdd || _options.modeManager.showEdit || _options.modeManager.showCopy) {
        $bottomButtonBar.append($btnCancelBottom)
        $btnCancelBottom.on('click', btn_cancelClicked)
        $bottomButtonBar.append($btnApplyBottom)
        $btnApplyBottom.on('click', btn_applyClicked)
      }
      if (!_options.modeManager.showApply) {
        $btnApplyBottom.css('display', 'none')
      }
      if (!_options.modeManager.showCancel) {
        $btnCancelBottom.css('display', 'none')
      }
      if (_options.modeManager.showCopy) {
        $bottomButtonBar.append($btnCopyBottom)
        $btnCopyBottom.on('click', btn_copyClicked)
      }
      if (_options.modeManager.showDelete) {
        $bottomButtonBar.append($btnDeleteBottom)
      }
      if (_options.modeManager.showExport) {
        $bottomButtonBar.append($btnExportBottom)
      }
      if (_options.modeManager.showUpload) {
        $bottomButtonBar.append($btnUploadBottom)
      }
    }
  }

  function btn_addClicked(e) {
    if (_options.modeManager.currentMode == 'view') {
      //backup existing
      tempData = _.map(_dataView.getItems(), _.clone)
      //tempSelectedRows = _.map(_grid.getSelectedRows(), _.clone)
      tempSelectedRows = [];
      _grid.setSelectedRows([]);
      $('.slick-cell-checkboxsel').find(':checkbox').prop('disabled', true)
    }
    if (
      _options.modeManager.currentMode == 'initial' ||
      _options.modeManager.currentMode == 'view' ||
      _options.modeManager.currentMode == 'add'
    ) {
      $('.slick-cell-checkboxsel').find(':checkbox').prop('disabled', true)
      // var len= data.length;
      // if (len == 10) {
      //   alert("Each time only allow 10 records to add");
      //   return;
      // }
      // var d = (data[len] = {});
      // d["rownum"] = (len + 1);
      // var len = dataview.getData().length;
      // info.push(len);
      //let tempLastData = _dataView.getItems()[_dataView.getItems().length - 1]
      var d = {}
      _currentIndex--
      d[_dataView.getIdPropertyName()] = _currentIndex

      //_vm.data.splice(0, 0, d)
      vueslickgrid.data.splice(0, 0, d)
      _vm.$nextTick(() => {
        let selectedCell = []
        selectedCell = _.map(_grid.getSelectedRows(), _.clone)
        for (let rows in selectedCell) {
          selectedCell[rows]++
        }
        selectedCell.push(0)
        _grid.setSelectedRows(selectedCell)
      })

      _options.modeManager.currentMode = 'add'
      _self.onAddClicked.notify({
        grid: _grid,
        selectedRow: []
      },
        e,
        _self
      );
      toggleMode()
    }
  }

  function btn_editClicked(e) {
    if (_options.modeManager.currentMode == 'view') {
      // var len= data.length;
      if (_grid.getSelectedRows().length <= 0) {
        //TODO: alert
        updateSlickModal(
          'Info',
          'Pleaseselectonerow',
          false,
          false,
          true,
          null,
          null,
          btn_modalOkClicked
        )
        return
      }
      tempData = _.map(_dataView.getItems(), _.clone)

      _options.modeManager.currentMode = 'edit'
      //console.log(_options.modeManager.currentMode)
      _self.onEditClicked.notify({
        grid: _grid,
        selectedRow: []
      },
        e,
        _self
      );
      toggleMode()
    }
  }

  function btn_copyClicked() {
    if (_grid.getSelectedRows().length <= 0) {
      //TODO: alert
      updateSlickModal(
        'Info',
        'Pleaseselectonerow',
        false,
        false,
        true,
        null,
        null,
        btn_modalOkClicked
      )
      return
    }

    if (_options.modeManager.currentMode == 'view') {
      //backup existing
      tempData = _.map(_dataView.getItems(), _.clone)
      //tempSelectedRows = _.map(_grid.getSelectedRows(), _.clone)
      tempSelectedRows = []
    }
    if (
      _options.modeManager.currentMode == 'initial' ||
      _options.modeManager.currentMode == 'view' ||
      _options.modeManager.currentMode == 'add'
    ) {
      // var len= data.length;
      // if (len == 10) {
      //   alert("Each time only allow 10 records to add");
      //   return;
      // }
      // var d = (data[len] = {});
      // d["rownum"] = (len + 1);
      // var len = dataview.getData().length;
      // info.push(len);
      //let tempLastData = _dataView.getItems()[_dataView.getItems().length - 1]
      let copyRowIdxs = _grid.getSelectedRows()

      let selectedCell = []
      let tempRows = []
      let rowIndex = 0
      for (let i = copyRowIdxs.length - 1; i >= 0; i--) {
        let d = {}
        _currentIndex--
        d = _.clone(_dataView.getItemByIdx(copyRowIdxs[i]))
        d[_dataView.getIdPropertyName()] = _currentIndex

        tempRows.push(d)
        selectedCell.push(rowIndex)
        rowIndex++
      }
      //_vm.data.splice(0, 0, ...tempRows)
      vueslickgrid.data.splice(0, 0, ...tempRows)

      _grid.setSelectedRows(selectedCell)
      _options.modeManager.currentMode = 'add'
      toggleMode()
    }
  }

  function btn_cancelClicked() {

    if (_options.modeManager.showCancel) {
      updateSlickModal(
        'Cancel',
        'canceltheoperation',
        true,
        true,
        false,
        btn_modalCancelConfirmClicked,
        btn_modalCancelCancelClicked,
        null

      )
    }else{
      btn_modalCancelConfirmClicked()
    }

  }

  function btn_applyClicked() {

    if (_options.modeManager.showApply) {
      updateSlickModal(
        'Apply',
        'sureapplychange',
        true,
        true,
        false,
        btn_modalApplyConfirmClicked,
        btn_modalApplyCancelClicked,
        null
      )
    }else{
      btn_modalApplyConfirmClicked()
    }

  }

  /**
   * Apply -> confirm
   */
  function btn_modalApplyConfirmClicked(e) {
    if (_options.modeManager.currentMode == 'add') {
      _grid.getEditorLock().commitCurrentEdit()
      let addRowIdxs = _grid.getSelectedRows()

      let selectedCell = []
      let tempRows = []
      for (let i = addRowIdxs.length - 1; i >= 0; i--) {
        let d = {}
        _currentIndex--
        d = _.clone(_dataView.getItemByIdx(addRowIdxs[i]))
        d[_dataView.getIdPropertyName()] = _currentIndex

        tempRows.push(d)
      }

      _self.onAddConfirmed.notify({
        grid: _grid,
        selectedRow: tempRows
      },
        e,
        _self
      );

      //_vm.data = tempData
      //vueslickgrid.data = tempData;
      //_options.modeManager.currentMode = 'view'
      //_grid.setSelectedRows(tempSelectedRows)
      //_grid.onBeforeEditCell.unsubscribe(onBeforeEditCellHandler)

      //e.preventDefault();
      //e.stopPropagation();

      //toggleMode()
      //clean up the current Index
      //_currentIndex = 0;

    } else if (_options.modeManager.currentMode == 'edit') {
      //_vm.data = tempData
      _grid.getEditorLock().commitCurrentEdit()
      let addRowIdxs = _grid.getSelectedRows()
      console.log(_grid.getSelectedRows())
      let tempRows = []
      for (let i = addRowIdxs.length - 1; i >= 0; i--) {
        let d = {}
        d = _.clone(_dataView.getItemByIdx(addRowIdxs[i]))
        tempRows.push(d)
      }

      _self.onEditConfirmed.notify({
        grid: _grid,
        selectedRow: tempRows
      },
        e,
        _self
      );
      _grid.onBeforeEditCell.unsubscribe(onBeforeEditCellHandler)
      console.log(tempRows);

    } else if (_options.modeManager.currentMode == 'applied') { } else if (_options.modeManager.currentMode == 'uploaded') { } else if (_options.modeManager.currentMode == 'uploaded_applied') { }
  }

  function btn_modalOkClicked(e) { }

  function btn_modalApplyCancelClicked(e) { }

  function btn_modalCancelConfirmClicked(e) {
    if (_options.modeManager.currentMode == 'add') {
      vueslickgrid.data = tempData;
      _options.modeManager.currentMode = 'view'
      _grid.onBeforeEditCell.unsubscribe(onBeforeEditCellHandler)
      _grid.setSelectedRows([]);
      toggleMode();
      _currentIndex = 0;
      _self.onAddCancel.notify({
        grid: _grid,
        selectedRow: []
      },
        e,
        _self
      );
    } else if (_options.modeManager.currentMode == 'edit') {
      vueslickgrid.data = tempData;
      _options.modeManager.currentMode = 'view'
      _grid.onBeforeEditCell.unsubscribe(onBeforeEditCellHandler)
      _grid.setSelectedRows([]);
      toggleMode();
      _currentIndex = 0;
      _self.onEditCancel.notify({
        grid: _grid,
        selectedRow: []
      },
        e,
        _self
      );
    }
  }

  function btn_modalCancelCancelClicked(e) { }


  function toggleMode() {
    if (_options.modeManager.useTopButtonBar) {
      $btnAddTop.attr('disabled', true)
      $btnEditTop.attr('disabled', true)
      $btnCancelTop.attr('disabled', true)
      $btnApplyTop.attr('disabled', true)
      $btnCopyTop.attr('disabled', true)
      $btnDeleteTop.attr('disabled', true)
      $btnExportTop.attr('disabled', true)
      $btnUploadTop.attr('disabled', true)
    }
    if (_options.modeManager.useBottomButtonBar) {
      $btnAddBottom.attr('disabled', true)
      $btnEditBottom.attr('disabled', true)
      $btnCancelBottom.attr('disabled', true)
      $btnApplyBottom.attr('disabled', true)
      $btnCopyBottom.attr('disabled', true)
      $btnDeleteBottom.attr('disabled', true)
      $btnExportBottom.attr('disabled', true)
      $btnUploadBottom.attr('disabled', true)
    }
    //_vm.$refs.vueslickgrid.editable = false;
    //_vm.$refs.vueslickgrid.gridOptions.editable = false
    vueslickgrid.gridOptions.editable = false

    // _options.modeManager.currentMode = _defaultMode.currentMode;

    if (_options.modeManager.currentMode == 'add') {
      //$( "#btn_edit" ).button( "option", "disabled", false );
      if (_options.modeManager.useTopButtonBar) {
        $btnAddTop.attr('disabled', false)
        $btnCancelTop.attr('disabled', false)
        $btnApplyTop.attr('disabled', false)
      }
      if (_options.modeManager.useBottomButtonBar) {
        $btnAddBottom.attr('disabled', false)
        $btnCancelBottom.attr('disabled', false)
        $btnApplyBottom.attr('disabled', false)
      }
      //update grid to allow edit
      // _vm.$refs.vueslickgrid.editable = true;
      // _options.modeManager.editable = true;
      _grid.onBeforeEditCell.subscribe(onBeforeEditCellHandler)
      _options.modeManager.currentMode = 'add'
      //_vm.$refs.vueslickgrid.gridOptions.editable = true
      vueslickgrid.gridOptions.editable = true
      // disableSearch();
    } else if (_options.modeManager.currentMode == 'edit') {
      //$( "#btn_edit" ).button( "option", "disabled", false );
      if (_options.modeManager.useTopButtonBar) {
        $btnCancelTop.attr('disabled', false)
        $btnApplyTop.attr('disabled', false)
      }
      if (_options.modeManager.useBottomButtonBar) {
        $btnCancelBottom.attr('disabled', false)
        $btnApplyBottom.attr('disabled', false)
      }
      // _vm.$refs.vueslickgrid.$on('before-cell-edit', (e,args) => {
      //   // $.inArray()
      //   let selectedRows = _vm.$refs.vueslickgrid.getSelectedRows();
      //   let isSelected = false;
      //   for(let row in selectedRows){
      //     if(selectedRows[row].id == args.row){
      //       isSelected = true;
      //       break;
      //     }
      //   }
      //   if(!isSelected){
      //     return false;
      //     e.stopImmediatePropagation();
      //   }
      //   console.log(e);
      //   console.log(args);

      //   ; });
      //_vm.$refs.vueslickgrid.gridOptions.editable = true
      // _options.modeManager.currentMode = 'view';
      vueslickgrid.gridOptions.editable = true
      _grid.onBeforeEditCell.subscribe(onBeforeEditCellHandler)

      //update grid to allow edit
      // _options.modeManager.editable = true;
      //_vm.$refs.vueslickgrid.editable = true;
      // disableSearch();
    } else if (_options.modeManager.currentMode == 'view') {
      //$( "#btn_edit" ).button( "option", "disabled", false );
      if (_options.modeManager.useTopButtonBar) {
        $btnEditTop.attr('disabled', false)
        $btnCopyTop.attr('disabled', false)
        $btnDeleteTop.attr('disabled', false)
        $btnAddTop.attr('disabled', false)
        $btnExportTop.attr('disabled', false)
        $btnUploadTop.attr('disabled', false)
      }
      if (_options.modeManager.useBottomButtonBar) {
        $btnEditBottom.attr('disabled', false)
        $btnCopyBottom.attr('disabled', false)
        $btnDeleteBottom.attr('disabled', false)
        $btnAddBottom.attr('disabled', false)
        $btnExportBottom.attr('disabled', false)
        $btnUploadBottom.attr('disabled', false)
      }
      //update grid to allow edit
      // _options.modeManager.ediable = true;

      _options.modeManager.currentMode = 'view'
      // disableSearch();
    } else if (_options.modeManager.currentMode == 'initial') {
      //$( "#btn_edit" ).button( "option", "disabled", false );
      if (_options.modeManager.useTopButtonBar) {
        $btnAddTop.attr('disabled', false)
        $btnUploadTop.attr('disabled', false)
      }
      if (_options.modeManager.useBottomButtonBar) {
        $btnAddBottom.attr('disabled', false)
        $btnUploadBottom.attr('disabled', false)
      }
      //update grid to allow edit
      // _options.modeManager.ediable = true;
      // _options.modeManager.currentMode = "view";
      // disableSearch();
    } else if (_options.modeManager.currentMode == 'applied') {
      _options.modeManager.currentMode = "view";
      _currentIndex = 0;
      //$( "#btn_edit" ).button( "option", "disabled", false );
      if (_options.modeManager.useTopButtonBar) {
        $btnEditTop.attr('disabled', false)
        $btnCopyTop.attr('disabled', false)
        $btnDeleteTop.attr('disabled', false)
        $btnAddTop.attr('disabled', false)
        $btnExportTop.attr('disabled', false)
        $btnUploadTop.attr('disabled', false)
        $btnCancelTop.attr('disabled', false)
      }
      if (_options.modeManager.useBottomButtonBar) {
        $btnEditBottom.attr('disabled', false)
        $btnCopyBottom.attr('disabled', false)
        $btnDeleteBottom.attr('disabled', false)
        $btnAddBottom.attr('disabled', false)
        $btnExportBottom.attr('disabled', false)
        $btnUploadBottom.attr('disabled', false)
      }


      //update grid to allow edit
      // _options.modeManager.ediable = true;
      // disableSearch();
    } else if (_options.modeManager.currentMode == 'uploaded') {
      //$( "#btn_edit" ).button( "option", "disabled", false );
      if (_options.modeManager.useTopButtonBar) {
        $btnCancelTop.attr('disabled', false)
        $btnApplyTop.attr('disabled', false)
      }
      if (_options.modeManager.useBottomButtonBar) {
        $btnCancelBottom.attr('disabled', false)
        $btnApplyBottom.attr('disabled', false)
      }
      //update grid to allow edit
      // _options.modeManager.ediable = true;
      _options.modeManager.currentMode = 'view'
      // disableSearch();
    } else if (_options.modeManager.currentMode == 'uploaded_applied') {
      //$( "#btn_edit" ).button( "option", "disabled", false );
      if (_options.modeManager.useTopButtonBar) {
        $btnCancelTop.attr('disabled', false)
      }
      if (_options.modeManager.useBottomButtonBar) {
        $btnCancelBottom.attr('disabled', false)
      }
      //update grid to allow edit
      // _options.modeManager.ediable = true;
      _options.modeManager.currentMode = 'view'
      // disableSearch();
    }
  }

  function updateSlickModal(title, body, showConfirm, showCancel, showOk, _btn_modalApplyConfirmClicked, _btn_modalApplyCancelClicked, _btn_modalOkClicked) {
    $slickModal.find('.modal-title').empty()
    $slickModal.find('.modal-title').text(helper.getWord(title))
    $slickModal.find('.modal-body').empty()
    $slickModal.find('.modal-body').html(helper.getWord(body))

    let $btnConfirm = $(
      '<button class="btn btn-primary" data-dismiss="modal">'+helper.getWord('Confirm')+'</button>'
    )
    let $btnCancel = $(
      '<button class="btn btn-outline-primary" data-dismiss="modal" >'+helper.getWord('Cancel')+'</button>'
    )
    let $btnOk = $(
      '<button class="btn btn btn-primary " data-dismiss="modal" >'+helper.getWord('Ok')+'</button>'
    )

    $slickModal.find('.modal-footer').empty()
    if (showOk) {
      $slickModal.find('.modal-footer').append($btnOk)
      $btnOk.on('click', _btn_modalOkClicked)
    }

    if (showConfirm) {
      $slickModal.find('.modal-footer').append($btnConfirm)
      $btnConfirm.on('click', _btn_modalApplyConfirmClicked)
    }

    if (showCancel) {
      $slickModal.find('.modal-footer').append($btnCancel)
      $btnCancel.on('click', _btn_modalApplyCancelClicked);
    }
    $slickModal.modal()
  }

  function updateModeManagerUI() { }

  function setMode(mode) {
    _options.modeManager.currentMode = mode
  }

  function setIsUseBottomButtonBar(val) {
    _options.modeManager.useBottomButtonBar = val
  }

  function setIsUseTopButtonBar(val) {
    _options.modeManager.useTopButtonBar = val
  }

  function onBeforeEditCellHandler(row, col, dataContext) {
    if (jQuery.inArray(col.row, _grid.getSelectedRows()) < 0) {
      console.log(_grid.getSelectedRows())
      return false
    }
  }

  function destroy() { }

  $.extend(this, {
    init: init,
    destroy: destroy,
    setIsUseBottomButtonBar: setIsUseBottomButtonBar,
    setIsUseTopButtonBar: setIsUseTopButtonBar,
    onAddClicked: new Slick.Event(),
    onAddConfirmed: new Slick.Event(),
    onAddCancel: new Slick.Event(),
    onEditConfirmed: new Slick.Event(),
    onEditClicked: new Slick.Event(),
    onEditCancel: new Slick.Event(),
    toggleMode: toggleMode
  })
}